import callApi from '../common/api/apiRequest'

export default (roomId: string, roomKey: string, participantKey: string): Promise<void> => {
  return callApi<void>('put', `rooms/removeBreakoutRoomCredentialsFromParticipant`, {
    roomId,
    roomKey,
    participantKey,
  })
}
